import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { Button } from '../components/ui/button';
import SongCard from '../components/SongCard';
import { UserPlus, UserCheck, Settings as SettingsIcon } from 'lucide-react';

export default function Profile() {
  const { userId } = useParams();
  const { t, lang, user, api } = useApp();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const d = await api.profile(userId); setData(d); } catch { setData(null); }
    setLoading(false);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [userId]);

  const toggleFollow = async () => {
    if (!user) return;
    try { const r = await api.followUser(userId); setData(prev => ({ ...prev, isFollowing: r.isFollowing, user: { ...prev.user, followers: r.followers } })); } catch {}
  };

  if (loading) return <div className="px-8 py-10 text-zinc-400">Loading...</div>;
  if (!data) return <div className="px-8 py-10 text-zinc-400">{lang==='fr'?'Utilisateur introuvable':'User not found'}</div>;

  const { user: p, songs, isFollowing, isSelf } = data;

  return (
    <div className="px-4 lg:px-8 py-6 fade-up">
      <div className="flex flex-col md:flex-row md:items-end gap-6 mb-8">
        <div className="w-28 h-28 md:w-36 md:h-36 rounded-full bg-gradient-to-br from-pink-500 via-orange-400 to-yellow-300 flex items-center justify-center text-black text-5xl font-black">
          {(p.name || 'U')[0].toUpperCase()}
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-xs uppercase tracking-wider text-zinc-500">{t('profile.songs')} · {songs.length}</div>
          <h1 className="font-display text-3xl md:text-5xl font-extrabold leading-tight mt-1">{p.name}</h1>
          {p.bio && <p className="text-sm text-zinc-400 mt-2 max-w-xl">{p.bio}</p>}
          <div className="flex items-center gap-4 text-sm text-zinc-400 mt-3">
            <span><strong className="text-zinc-100">{p.followers}</strong> {t('profile.followers')}</span>
            <span><strong className="text-zinc-100">{p.following}</strong> {t('profile.following')}</span>
          </div>
          <div className="mt-4 flex gap-2">
            {isSelf ? (
              <Link to="/settings"><Button variant="outline" className="border-white/15 bg-transparent hover:bg-white/5 gap-2"><SettingsIcon size={16}/> {t('profile.edit')}</Button></Link>
            ) : (
              user && (
                <Button onClick={toggleFollow} className={isFollowing ? 'bg-white/10 hover:bg-white/15 text-white gap-2' : 'bg-white text-black hover:bg-zinc-200 gap-2'}>
                  {isFollowing ? <><UserCheck size={16}/> {t('profile.unfollow')}</> : <><UserPlus size={16}/> {t('profile.follow')}</>}
                </Button>
              )
            )}
          </div>
        </div>
      </div>

      {songs.length === 0 ? (
        <div className="text-sm text-zinc-500 py-16 text-center border border-dashed border-white/10 rounded-2xl">{t('profile.no_songs')}</div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-4">
          {songs.map(s => <SongCard key={s.id} song={s} list={songs} />)}
        </div>
      )}
      <div className="h-24" />
    </div>
  );
}
